// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-datepicker-quarters {
  display: grid;
  grid-template-columns: 51px repeat(4, 53px);
  grid-template-rows: repeat(1, 40px);
  grid-gap: 4px;
  justify-content: center;
  margin-bottom: 4px;
}
.dl-datepicker-quarters__quarter {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  cursor: pointer;
}
.dl-datepicker_desktop .dl-datepicker-quarters__quarter:hover {
  background-color: var(--g-color-base-simple-hover);
}
.dl-datepicker-quarters__quarter_today {
  color: var(--g-color-text-info);
}
.dl-datepicker-quarters__quarter_selected {
  border-radius: 0;
  background-color: var(--g-color-base-selection);
}
.dl-datepicker_desktop .dl-datepicker-quarters__quarter_selected:hover {
  background-color: var(--g-color-base-selection);
}
.dl-datepicker-quarters__quarter_left-edge {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.dl-datepicker-quarters__quarter_right-edge {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dl-datepicker-quarters__quarter_selected:not(.dl-datepicker-quarters__quarter_left-edge)::before {
  content: "";
  position: absolute;
  top: 0;
  left: -4px;
  display: block;
  height: 40px;
  width: 4px;
  background-color: var(--g-color-base-selection);
}
.dl-datepicker-quarters__quarter_disabled {
  opacity: 0.3;
  pointer-events: none;
}
.dl-datepicker-quarters__title {
  align-self: center;
  font-size: 18px;
  line-height: 20px;
  color: var(--g-color-text-secondary);
}
.dl-datepicker-quarters__title_disabled {
  opacity: 0.3;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/Datepicker/Quarters/Quarters.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2CAAA;EACA,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACR;AACQ;EACI,kDAAA;AACZ;AAEQ;EACI,+BAAA;AAAZ;AAGQ;EACI,gBAAA;EACA,+CAAA;AADZ;AAGY;EACI,+CAAA;AADhB;AAKQ;EACI,2BAAA;EACA,8BAAA;AAHZ;AAMQ;EACI,4BAAA;EACA,+BAAA;AAJZ;AAOQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;AALZ;AAQQ;EACI,YAAA;EACA,oBAAA;AANZ;AAUI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;AARR;AAUQ;EACI,YAAA;EACA,oBAAA;AARZ","sourcesContent":[".dl-datepicker-quarters {\n  display: grid;\n  grid-template-columns: 51px repeat(4, 53px);\n  grid-template-rows: repeat(1, 40px);\n  grid-gap: 4px;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n.dl-datepicker-quarters__quarter {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.dl-datepicker_desktop .dl-datepicker-quarters__quarter:hover {\n  background-color: var(--g-color-base-simple-hover);\n}\n.dl-datepicker-quarters__quarter_today {\n  color: var(--g-color-text-info);\n}\n.dl-datepicker-quarters__quarter_selected {\n  border-radius: 0;\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker_desktop .dl-datepicker-quarters__quarter_selected:hover {\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker-quarters__quarter_left-edge {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.dl-datepicker-quarters__quarter_right-edge {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.dl-datepicker-quarters__quarter_selected:not(.dl-datepicker-quarters__quarter_left-edge)::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -4px;\n  display: block;\n  height: 40px;\n  width: 4px;\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker-quarters__quarter_disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}\n.dl-datepicker-quarters__title {\n  align-self: center;\n  font-size: 18px;\n  line-height: 20px;\n  color: var(--g-color-text-secondary);\n}\n.dl-datepicker-quarters__title_disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
